//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TheMenu from "../components/partials/TheMenu.vue";
import TheButton from "../../components/general/TheButton.vue";
import { mapMutations } from "vuex";
import User from "~/assets/js/User";

export default {
  name: "TheHeader",
  components: {
    TheMenu,
    TheButton,
  },
  data() {
    return {
      active: false,
      isAuthenticated: false, //to move in store
      userData: this.$localStore.get("userData"),
    };
  },
  computed: {
    autenticated() {
      return this.$localStore.get("authenticated");
    },
    username() {
      return this.$localStore.get("name")
        ? this.$localStore.get("name")
        : this.$localStore.get("username");
    },
    welcomeMessage() {
      let date = new Date();
      let currentHour = date.getHours();
      return currentHour > 12 ? "Buonasera" : "Buongiorno";
    },
  },
  methods: {
    ...mapMutations({ toggle: "authPopup/toggle" }),
    ...mapMutations({ openSignIn: "authPopup/openSignIn" }),
    closeMenu() {
      this.active = false;
    },
    signOut() {
      this.$localStore.clearAll();
      this.$cookies.remove("authenticated");
      User.signOut();
      window.location.href = "/";
    },
  },
};
